module.exports = __webpack_public_path__ + "static/media/GolosText-Medium.b04f2d4e.ttf";